<life-di-nav></life-di-nav>
<lifedi-breadcrumb *ngIf="measure && !isHidden" [lastPath]="measure.MEASURE_NAME"></lifedi-breadcrumb>

<div *ngIf="measure && !isHidden" class="container">
  <div class="row justify-content-center">
    <div class="col-12">
      <h1 class="lifedi-color text-center mt-3">
        {{ measure.MEASURE_NAME }}
      </h1>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <h3><b>รายละเอียด</b></h3>
    </div>
    <div class="col-12 my-2">
      <div id="_content" [innerHtml]="measureDetail"></div>
    </div>
  </div>

  <div *ngIf="suggestCourse.length > 0" class="card-course px-3 pt-4 pb-2 mt-4">
    <div class="row">
      <h3 class="col-12">คอร์สแนะนำ</h3>
    </div>
    <!-- desktop size -->
    <div *ngIf="suggestCourse.length > 0 && suggestCourse.length >= 4"
      class="d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let c of suggestCourse">
          <ng-template carouselSlide>
            <lifedi-course-card (viewCourse)="viewCourse(c.COURSE_ID)" [title]="c.COURSE_NAME" [imageUrl]="c.COURSE_PIC"
              [haveFavorite]="false" [teacherName]="c.USERNAME" [price]="c.COURSE_PRICE"
              [premiumPrice]="c.COURSE_SPECIALPRICE" [isPremium]="c.IS_PREMIUM" style="outline: none;">
            </lifedi-course-card>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>

    <div *ngIf="suggestCourse.length > 0 && suggestCourse.length < 4"
      class="container pt-4 d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
      <div class="row">
        <div *ngFor="let c of suggestCourse" class="col-lg-3 col-md-4 col-sm-6 mb-4">
          <lifedi-course-card (viewCourse)="viewCourse(c.COURSE_ID)" [title]="c.COURSE_NAME" [imageUrl]="c.COURSE_PIC"
            [haveFavorite]="false" [teacherName]="c.USERNAME" [price]="c.COURSE_PRICE"
            [premiumPrice]="c.COURSE_SPECIALPRICE" [isPremium]="c.IS_PREMIUM" style="outline: none;">
          </lifedi-course-card>
        </div>
      </div>
    </div>
    <!-- desktop size -->

    <!-- mobile size -->
    <div *ngIf="suggestCourse.length > 0" class="d-none d-block d-sm-block d-md-none">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let c of suggestCourse">
          <ng-template carouselSlide>
            <lifedi-course-card (viewCourse)="viewCourse(c.COURSE_ID)" [title]="c.COURSE_NAME" [imageUrl]="c.COURSE_PIC"
              [haveFavorite]="false" [teacherName]="c.USERNAME" [price]="c.COURSE_PRICE"
              [premiumPrice]="c.COURSE_SPECIALPRICE" [isPremium]="c.IS_PREMIUM" style="outline: none;">
            </lifedi-course-card>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
    <!-- mobile size -->
  </div>

  <div class="row justify-content-center py-3">
    <lifedi-btn *ngIf="!measure.IS_LOGIN" lable="เข้าสู่ระบบ เพื่อทำแบบทดสอบ" class="mr-3"
      customStyle="color:white; background-color: #414A6B; width: 100%;" (click)="openLogin()">
    </lifedi-btn>
    <lifedi-btn *ngIf="measure.IS_LOGIN" lable="เริ่มทำแบบทดสอบ" (click)="colloectAccessLink()" class="mr-3"
      customStyle="background-color: #3E8C1A; color: #FFF; width: 100%;">
    </lifedi-btn>
    <lifedi-btn lable="ย้อนกลับ" (click)="close()" customStyle="background-color: #C4C4C4; color: #FFF; width: 100%;">
    </lifedi-btn>
  </div>
</div>
